import MidiPlayer from 'midi-player-js';
// import animated_dots_container from "laravel-mix/src/File";

$(".grey-heart").click(function (e) {
    e.preventDefault()
    e.stopPropagation()
    $(this).toggleClass("red-heart");
})
$(document).ready(function () {
    // Initialize player and register event handler
    var notes = [71, 76, 64, 79, 78, 83, 81, 75, 70, 59, 77, 67, 74, 85, 60, 72, 65, 84, 68, 80, 69, 45, 44, 82, 61, 66, 90, 62];
    notes.sort();

    function swap(json) {
        var ret = {};
        for (var key in json) {
            ret[json[key]] = key * 1;
        }
        return ret;
    }

    var final_notes = swap(notes);
    var Player = new MidiPlayer.Player(function (event) {
        if (typeof event.noteNumber === 'undefined') {
            return;
        }
        var sel = Math.floor(final_notes[event.noteNumber] / 1.7);
        if (sel == 0) {
            sel = 1;
        }
        var el = $('.building-footer').find('svg > g > g:nth-child(' + sel + ')');
        if (event.name == 'Note on') {
            el.attr('class', 'hover');
        } else {
            el.attr('class', '');
        }
    });

    // Load a MIDI file
    window.song = 'data:audio/midi;base64,TVRoZAAAAAYAAAABAeBNVHJrAAAFWgD/IAEAAP8DCHRtYyAoMSlpAP8EFFN0ZWlud2F5IEdyYW5kIFBpYW5vAP9YBAQCGAgA/1kCAAAA/1QFIAAAAAAA/1EDB6EgAMAAAJBHI4JOkEwpFZBAFoIagEdAgRKATEAfkE8egRKAT0AAkE4aNJBPDx+AT0A1gEBAcoBOQCCQTCkKkEAhg0GATEBekFMjggWAU0BTkFEqgniAUUCDf4BAQACQTiQVkEAWgmOATkCCOYBAQIE8kEAkAEwqg1WATEALkE8hgQeQTicLgE9AghmQSy4LkEYhCoBAQAuATkCDVYBLQFSQOx0ATS4KgEZAgkSQRyYVkEAkaIA7QD+ATUCDDJBDJIVQgENAKoBAQIESkDscgi6QQC4ATDKBCIA7QIFbgEdAgR2QTxRTgExAFZBOKguAT0CCLpBMLkmATkCDDYBMQHOQUySCD4BTQACQSjMKkEMrP4BAQACQRheDYIBGQF6QVRuBW4BDQAqASkAVgFVAAJA8HQBIIzSQQRsLkE0pCpBUNSqQRBmBZoBIQIExgFRAXpBQLRWQVAmBB4BEQHOAPEAAQUALkDwgCoBUQAqATUALkEwtFZBAIQBFIhWQLRkVkFQ0FIAtQABQQDWQLA8fgCxAgRKARUAqgFRAcpBTJQuATEBzkFIdCoBTQCqQUxFTgFNAXoA8QCqAUkAqgEBAAJA9KgBSHwqQRjALkEAhNIBAQACQQiRTgEJAC5BAIABCJBWAQEAAQkA0kEAfAEIjFYBAQABCQAqQQiUqkEAdFYBAQABCQAqQQiELgFJACpBAHQqAQkAggEBAH5BAGSqAQEAfkEAXP5BPJwqAQEALkEAmgQeARkCBMpBMMhSAPUAAT0CEH4BMQBWQQySCWJBHH4IkgEBAC4BDQIIFkE8jCpA7HEmAR0CCBZBTIwuAT0AAkEAmaIA7QCqAU0AfkFMQaIBTQIIQkEMngk2QUyQLkEcfgVGAU0CBMYBDQIESgEBAC5A7HgBPHn2AR0B9gE9AXpBUMgqQQChzgDtAgTyAVECBcJBDKABTJoIagFNAKZBIJABSKoMCgEhAgROAQ0AfgEBAAFJACpBOLAuQOyOCToBOQACQTykVkEAnH4A7QAqQOxBJgDtAghCAT0AfkFMbfYBTQACQUiMLkEMcghmAUkA0kDwlC4BAQAqAQ0AAkEYphBWARkAAkEcqCpBDIzSQWgo0gFpAgUeQUywUgDxAAJBAJiqAQ0CBcIBTQDSAR0BpkFMKfYBTQAqQQyKCRJBHHIIagENAgjmQTx4UgEBAC5A7FnOAR0CBPIBPQACQUyUfkEAcPoA7QIE8gFNAgi+QQymCTpBHGwqQUyM/gEBAgUaAU0CBEoBDQH2QQysVgEdAC5BHCSmAR0CBZpA+GwBKMCqAQ0AKkEMsAEYlgRKAPkCDApBVHlSARkBTgENAFYBKQD+AVUAVkEgnCpA8Gh+QQSEVkE0mFZBEIxWAPEAAkFQ5FZA8EYIPgEhAAFRAgVuQUCx+kFQNNIA8QABNQAqAQUBJgERAFZBHEyqQQCMATDMVgFRACoBQQACQOxUAQyMqkFQ1gjmAVEBTkFMjaYBHQAqAU0AAkFItAFQLC4BMQACQUxIpgFNANIBDQIFmkEMNAEYuCoA7QABAQAuQPSgKgENAAFRAC5BAIxWAQEAfkEIgCoBSQAuAQkAKkEImIIBCQAqQQCQAQiMVgEBAAEJANJBAJQBCJBWAQEAAQkAfkEAiFZBCIRWAQEAAQkAfkEAhgVuQTyF+gEZAgVuAT0AAkEwvFYA9QINAgExAfpBDI4JDkEcXFYBAQIIugENAgR2AR0AA/y8A';
    Player.loadDataUri(window.song);
    window.song_is_playing = false;

    function display_message(mes) {
        Player.play();
        window.song_is_playing = true;
        Player.on('endOfFile', function () {
            $('.building-footer').find('svg > g > g.hover').attr('class', '');
            window.song_is_playing = false;
        });
    }

    let playCount = 0;

    $(document).on('click', '[data-tmcpartmidi-start]', function () {
        MIDIjs.message_callback = display_message;

        if (playCount % 2 === 0) {
            if (!window.song_is_playing) {
                MIDIjs.play('/tmcpart.midi');
                window.song_is_playing = true;
            }
        } else {
            MIDIjs.stop();
            $('.building-footer').find('svg > g > g.hover').attr('class', '');
            window.song_is_playing = false;
        }
        playCount++;
    });
});

//BURGER MENU FRONT

let studentMenuOpen = false;

$(".burger-menu").click((e) => {
    $("#mySidenav").fadeIn(300);
});

$(".front-sidenav-close").click((e) => {
    $("#mySidenav").fadeOut(300);
});

$(".burger-menu-student").click((e) => {
    let menu = $("#mySidenav-student");

    if (!studentMenuOpen) {

        menu.fadeIn(300);
        $('.right-dashboard').css({
            'position': 'fixed',
        });
        $('.overlay').show();
        $(".burger-menu-student").css({
            position: 'absolute',
            zIndex: 999,
            left: '250px',
            top: 0,
            transition: "all ease 0.3s"
        });
    } else {

        menu.fadeOut(300);
        $('.right-dashboard').css({
            'position': 'relative',
        });
        $('.overlay').hide();
        $(".burger-menu-student").css({
            position: 'static',
            display: "block"
        });
    }

    studentMenuOpen = !studentMenuOpen;
});

$(".close-btn-student").click((e) => {
    let menu = $("#mySidenav-student");
    menu.fadeOut(300);
    $('.right-dashboard').css({
        'position': 'relative',
    });
    $('.overlay').hide();
    $(".burger-menu-student").css({
        position: 'static',
        display: "block"
    });

    studentMenuOpen = false;
});

$(document).on('click', '.about-course', function (e) {
    if ($(this).find('a.green-btn').length) {
        var href = $(this).find('a.green-btn').attr('href');
        if ("ontouchstart" in document.documentElement) {
            document.location.href = href;
        }
    }
})

$(document).ready(function () {
    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    let mobile_input = document.querySelector('#mobile_number_got_questions_form')
    let iti;
    if (mobile_input) {
        iti = window.intlTelInput(mobile_input, {
            preferredCountries: ['ae', 'in', 'ru', 'de'],
            separateDialCode: true,
            customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
                return "e.g. " + selectedCountryPlaceholder;
            },
        });
    }
    const early_bird_popup = document.getElementById('got_questions_popup');
    const closeButton = document.getElementById('gotQuestionsCloseButton');

    if (closeButton) {
        closeButton.addEventListener('click', (e) => {
            early_bird_popup.style.display = 'none';
            setCookie('got_questions_popup_closed', 1, 3);
        });
    }

    if (!getCookie('got_questions_popup_closed') && !$('body').hasClass('course-bootcamp')) {
        setTimeout(function () {
            $('#got_questions_popup').fadeIn();
        }, 5000);
    }

    $(document).on('submit', '#got_questions_form', function (e) {
        e.preventDefault();
        var form = $(this)[0];
        var form_url = $(this).attr('action');
        var formArray = {};
        let mobile_prefix = '';
        if (typeof iti !== 'undefined') {
            mobile_prefix = iti.getSelectedCountryData().dialCode;
        }
        var val = '';

        for (var i = 0; i < form.length; i += 1) {
            val = form[i].value;
            if (form[i].name == 'phone') {
                val = '+' + mobile_prefix + val;
            }
            formArray[form[i].name] = val;
        }

        $(this).hide();
        $("#got-questions-form-area .send-suggestion-spinner").show();
        $('#got_questions_form .errors_area').html('').hide();

        axios.post(form_url, formArray).then(({data}) => {
            let current_fs, next_fs
            let left, opacity, scale;

            current_fs = $('fieldset#got-questions-form-area').hide()
            next_fs = current_fs.next();

            next_fs.show();
            current_fs.animate({opacity: 0}, {
                step: function (now) {
                    scale = 0.8 + (1 - now) * 0.2;
                    left = ((1 - now) * 50) + "%";
                    opacity = 1 - now;
                    current_fs.css({'left': left});
                    next_fs.css({'transform': 'scale(' + scale + ')', 'opacity': opacity});
                },
                duration: 400
            });
            setCookie('got_questions_popup_closed', 1, 3);

            setTimeout(function () {
                $('#got_questions_popup').fadeOut();
            }, 6000);
        })
            .catch(function (error) {
                if (error.response) {
                    var errors = [];
                    for (i in error.response.data.errors) {
                        let j;
                        for (j in error.response.data.errors[i]) {
                            errors.push(error.response.data.errors[i][j]);
                        }
                    }
                    $('#got_questions_form').show();
                    $('#got_questions_form .errors_area').html("<p>" + errors.join('<br />') + "</p>").show();
                    $('#got-questions-form-area .send-suggestion-spinner').hide();
                    $('fieldset#got-questions-form-area').next().hide();
                }
            })
    })

    let mobile_input2 = document.querySelector('#mobile_callback')
    let iti2;
    if (mobile_input2) {
        iti2 = window.intlTelInput(mobile_input2, {
            preferredCountries: ['ae', 'in', 'ru', 'de'],
            separateDialCode: true,
            customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
                return "e.g. " + selectedCountryPlaceholder;
            },
        });
    }

    $(document).on('submit', '#request-callback', function (e) {
        e.preventDefault();

        let firstName = $('#firstName').val();
        let lastName = $('#lastName').val();
        let fullName = firstName + ' ' + lastName;

        $('#fullName').val(fullName);


        var form = $(this)[0];
        var form_url = $(this).attr('action');
        var formArray = {};
        let mobile_prefix = '';
        if (typeof iti2 !== 'undefined') {
            mobile_prefix = iti2.getSelectedCountryData().dialCode;
        }
        var val = '';

        for (var i = 0; i < form.length; i += 1) {
            val = form[i].value;
            if (form[i].name == 'phone') {
                val = '+' + mobile_prefix + val;
            }
            formArray[form[i].name] = val;
        }


        $(this).hide();
        $("#contact_request_back_form .send-suggestion-spinner").show();
        $('#request-callback .errors_area').html('').hide();

        axios.post(form_url, formArray).then(({data}) => {
            let current_fs, next_fs
            let left, opacity, scale;

            current_fs = $('fieldset#contact_request_back_form').hide()
            next_fs = current_fs.next();

            next_fs.show();
            current_fs.animate({opacity: 0}, {
                step: function (now) {
                    scale = 0.8 + (1 - now) * 0.2;
                    left = ((1 - now) * 50) + "%";
                    opacity = 1 - now;
                    current_fs.css({'left': left});
                    next_fs.css({'transform': 'scale(' + scale + ')', 'opacity': opacity});
                },
                duration: 400
            });

            setTimeout(function () {
                $('.request-callback').fadeOut();
            }, 6000);
        })
            .catch(function (error) {
                if (error.response) {
                    var errors = [];
                    for (i in error.response.data.errors) {
                        let j;
                        for (j in error.response.data.errors[i]) {
                            errors.push(error.response.data.errors[i][j]);
                        }
                    }
                    $('#request-callback').show();
                    $('#request-callback .errors_area').html("<p>" + errors.join('<br />') + "</p>").show();
                    $('#contact_request_back_form .send-suggestion-spinner').hide();
                    $('fieldset#contact_request_back_form').next().hide();
                }
            })
    })
});

document.addEventListener('DOMContentLoaded', function () {
    // Selectează toate elementele cu clasa 'hover-anim-1'
    const hoverContainers = document.querySelectorAll('.hover-anim-1');
    hoverContainers.forEach(function (hoverContainer) {
        // Creează un element div pentru a conține SVG-ul
        const arrowDiv = document.createElement('div');
        arrowDiv.classList.add('arrow');

        // Adaugă SVG-ul în elementul creat
        arrowDiv.innerHTML = `
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="fi-rr-angle-small-right">
                    <path id="Vector" d="M12.8336 8.23408L9.0086 4.40908C8.85246 4.25387 8.64125 4.16675 8.4211 4.16675C8.20094 4.16675 7.98973 4.25387 7.8336 4.40908C7.75549 4.48654 7.69349 4.57871 7.65119 4.68026C7.60888 4.78181 7.5871 4.89073 7.5871 5.00074C7.5871 5.11075 7.60888 5.21967 7.65119 5.32122C7.69349 5.42277 7.75549 5.51494 7.8336 5.59241L11.6669 9.40908C11.745 9.48654 11.807 9.57871 11.8493 9.68026C11.8916 9.78181 11.9134 9.89073 11.9134 10.0007C11.9134 10.1108 11.8916 10.2197 11.8493 10.3212C11.807 10.4228 11.745 10.5149 11.6669 10.5924L7.8336 14.4091C7.67668 14.5649 7.58808 14.7767 7.5873 14.9978C7.58652 15.2189 7.67362 15.4313 7.82943 15.5882C7.98524 15.7452 8.19701 15.8338 8.41815 15.8345C8.63929 15.8353 8.85168 15.7482 9.0086 15.5924L12.8336 11.7674C13.3018 11.2987 13.5647 10.6632 13.5647 10.0007C13.5647 9.33824 13.3018 8.70283 12.8336 8.23408Z" fill="#171717"/>
                </g>
            </svg>
        `;

        hoverContainer.appendChild(arrowDiv);


    });
});

let swal = null;

window.customSwal = function(isSuccessful, message, callTime = '') {
    const iconSvg = isSuccessful
        ? `<svg width="131" height="132" viewBox="0 0 131 132" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M57.5 5.1188C62.4504 2.26068 68.5496 2.26068 73.5 5.1188L114.225 28.6312C119.175 31.4893 122.225 36.7714 122.225 42.4876V89.5124C122.225 95.2286 119.175 100.511 114.225 103.369L73.5 126.881C68.5496 129.739 62.4504 129.739 57.5 126.881L16.7753 103.369C11.8249 100.511 8.77534 95.2286 8.77534 89.5124V42.4876C8.77534 36.7714 11.8249 31.4893 16.7753 28.6312L57.5 5.1188Z" fill="#E6F5E6"/>
            <g clip-path="url(#clip0_28350_86326)">
            <path d="M85.6373 50.862L57.9993 78.498C57.8134 78.6846 57.5926 78.8326 57.3495 78.9336C57.1063 79.0346 56.8456 79.0866 56.5823 79.0866C56.319 79.0866 56.0582 79.0346 55.8151 78.9336C55.5719 78.8326 55.3511 78.6846 55.1653 78.498L44.4773 67.8C44.2914 67.6135 44.0706 67.4654 43.8275 67.3644C43.5843 67.2634 43.3236 67.2114 43.0603 67.2114C42.797 67.2114 42.5362 67.2634 42.2931 67.3644C42.0499 67.4654 41.8291 67.6135 41.6433 67.8C41.4567 67.9858 41.3087 68.2067 41.2077 68.4498C41.1067 68.693 41.0547 68.9537 41.0547 69.217C41.0547 69.4803 41.1067 69.741 41.2077 69.9842C41.3087 70.2274 41.4567 70.4482 41.6433 70.634L52.3353 81.324C53.4632 82.4498 54.9917 83.0821 56.5853 83.0821C58.1789 83.0821 59.7074 82.4498 60.8353 81.324L88.4713 53.694C88.6575 53.5082 88.8053 53.2875 88.9061 53.0446C89.0069 52.8016 89.0588 52.5411 89.0588 52.278C89.0588 52.0149 89.0069 51.7545 88.9061 51.5115C88.8053 51.2685 88.6575 51.0478 88.4713 50.862C88.2854 50.6755 88.0646 50.5274 87.8215 50.4264C87.5783 50.3254 87.3176 50.2734 87.0543 50.2734C86.791 50.2734 86.5302 50.3254 86.2871 50.4264C86.0439 50.5274 85.8231 50.6755 85.6373 50.862Z" fill="#019900"/>
            </g>
            <defs>
            <clipPath id="clip0_28350_86326">
            <rect width="48" height="48" fill="white" transform="translate(41 42)"/>
            </clipPath>
            </defs>
        </svg>`
        : `<svg width="131" height="132" viewBox="0 0 131 132" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M57.5 5.1188C62.4504 2.26068 68.5496 2.26068 73.5 5.1188L114.225 28.6312C119.175 31.4893 122.225 36.7714 122.225 42.4876V89.5124C122.225 95.2286 119.175 100.511 114.225 103.369L73.5 126.881C68.5496 129.739 62.4504 129.739 57.5 126.881L16.7753 103.369C11.8249 100.511 8.77534 95.2286 8.77534 89.5124V42.4876C8.77534 36.7714 11.8249 31.4893 16.7753 28.6312L57.5 5.1188Z" fill="#FFF1F0"/>
            <path d="M77 54.0001C76.6249 53.6252 76.1163 53.4146 75.586 53.4146C75.0557 53.4146 74.5471 53.6252 74.172 54.0001L65 63.1721L55.828 54.0001C55.4529 53.6252 54.9443 53.4146 54.414 53.4146C53.8837 53.4146 53.3751 53.6252 53 54.0001C52.6251 54.3752 52.4144 54.8838 52.4144 55.4141C52.4144 55.9445 52.6251 56.4531 53 56.8281L62.172 66.0001L53 75.1721C52.6251 75.5472 52.4144 76.0558 52.4144 76.5861C52.4144 77.1165 52.6251 77.6251 53 78.0001C53.3751 78.3751 53.8837 78.5857 54.414 78.5857C54.9443 78.5857 55.4529 78.3751 55.828 78.0001L65 68.8281L74.172 78.0001C74.5471 78.3751 75.0557 78.5857 75.586 78.5857C76.1163 78.5857 76.6249 78.3751 77 78.0001C77.3749 77.6251 77.5856 77.1165 77.5856 76.5861C77.5856 76.0558 77.3749 75.5472 77 75.1721L67.828 66.0001L77 56.8281C77.3749 56.4531 77.5856 55.9445 77.5856 55.4141C77.5856 54.8838 77.3749 54.3752 77 54.0001Z" fill="#FF554A"/>
        </svg>`;

    const titleColor = isSuccessful ? '#019900' : '#FF554A';
    const titleText = isSuccessful ? 'Successfully!' : 'Unsuccessfully!';
    const backgroundColor = isSuccessful ? '#E6F5E6' : '#FFF1F0';

    swal =  Swal.fire({
        html: `
        <div class="swal-content" style="background-color: #fff;">
            <div class="gotItBtn close-button" style="position: absolute; top: 12px; right: 12px; cursor: pointer;">
                <svg width="40" height="40" viewBox="0 0 30 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 8.5C4.65685 8.5 6 7.15685 6 5.5C6 3.84315 4.65685 2.5 3 2.5C1.34315 2.5 0 3.84315 0 5.5C0 7.15685 1.34315 8.5 3 8.5Z" fill="white"/>
                    <path d="M13 8.5C14.6569 8.5 16 7.15685 16 5.5C16 3.84315 14.6569 2.5 13 2.5C11.3431 2.5 10 3.84315 10 5.5C10 7.15685 11.3431 8.5 13 8.5Z" fill="white"/>
                    <path d="M25 10.5C27.7614 10.5 30 8.26142 30 5.5C30 2.73858 27.7614 0.5 25 0.5C22.2386 0.5 20 2.73858 20 5.5C20 8.26142 22.2386 10.5 25 10.5Z" fill="white"/>
                </svg>
            </div>
            <div class="swal-icon">
                ${iconSvg}
            </div>
            <h2 class="swal-title" style="padding: 25px 0;">Request Submitted <span style="color: ${titleColor};">${titleText}</span></h2>
            <p class="swal-message" style="margin-bottom: 32px;">${message}${callTime ? ` We will contact you in the ${callTime}.` : ''}</p>
            <button class="check-available hover-anim-1 m-auto gotItBtn">Got it!
            <div class="arrow">
               <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="fi-rr-angle-small-right">
                    <path id="Vector" d="M12.8336 8.23408L9.0086 4.40908C8.85246 4.25387 8.64125 4.16675 8.4211 4.16675C8.20094 4.16675 7.98973 4.25387 7.8336 4.40908C7.75549 4.48654 7.69349 4.57871 7.65119 4.68026C7.60888 4.78181 7.5871 4.89073 7.5871 5.00074C7.5871 5.11075 7.60888 5.21967 7.65119 5.32122C7.69349 5.42277 7.75549 5.51494 7.8336 5.59241L11.6669 9.40908C11.745 9.48654 11.807 9.57871 11.8493 9.68026C11.8916 9.78181 11.9134 9.89073 11.9134 10.0007C11.9134 10.1108 11.8916 10.2197 11.8493 10.3212C11.807 10.4228 11.745 10.5149 11.6669 10.5924L7.8336 14.4091C7.67668 14.5649 7.58808 14.7767 7.5873 14.9978C7.58652 15.2189 7.67362 15.4313 7.82943 15.5882C7.98524 15.7452 8.19701 15.8338 8.41815 15.8345C8.63929 15.8353 8.85168 15.7482 9.0086 15.5924L12.8336 11.7674C13.3018 11.2987 13.5647 10.6632 13.5647 10.0007C13.5647 9.33824 13.3018 8.70283 12.8336 8.23408Z" fill="#171717"/>
                </g>
            </svg>
            </div>
         
            </button>
        </div>`,
        showConfirmButton: false,
    });

    $(document).on('click', '.gotItBtn', () => {
        if (swal) {
            swal.close();
        }
    });

}

window.lessonsAwaitsYou = function(price) {
    const iconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="289" height="179" viewBox="0 0 289 179" fill="none">
<path d="M275.255 178.012H13.7435C6.46494 178.012 0.564453 172.111 0.564453 164.833V14.1673C0.564453 6.88874 6.46494 0.988281 13.7435 0.988281H275.255C282.534 0.988281 288.434 6.88874 288.434 14.1673V164.833C288.434 172.111 282.534 178.012 275.255 178.012Z" fill="white"/>
<path d="M275.256 178.576H13.7439C6.16557 178.576 0 172.411 0 164.832V14.1673C0 6.58893 6.16557 0.42334 13.7439 0.42334H275.256C282.834 0.42334 289 6.58893 289 14.1673V164.832C289 172.411 282.834 178.576 275.256 178.576ZM13.7439 1.55301C6.78814 1.55301 1.12943 7.21171 1.12943 14.1675V164.833C1.12943 171.788 6.78814 177.447 13.7439 177.447H275.256C282.211 177.447 287.87 171.788 287.87 164.833V14.1675C287.87 7.21171 282.211 1.55301 275.256 1.55301H13.7439Z" fill="#131313"/>
<path d="M174.581 151.942H22.0371V158.773H174.581V151.942Z" fill="#AA92FF"/>
<path d="M264.226 153.53H173.948V157.5H264.226V153.53Z" fill="#131313"/>
<path d="M176.307 148.863H171.59V161.487H176.307V148.863Z" fill="#AA92FF"/>
<path d="M241.198 16.3844C241.855 14.971 243.534 14.358 244.947 15.0153C246.361 15.6725 246.974 17.3512 246.317 18.7646C245.659 20.178 243.981 20.791 242.567 20.1339C241.153 19.4765 240.541 17.798 241.198 16.3844ZM241.441 21.5615C241.432 21.6597 241.424 21.7678 241.41 21.8751C241.382 22.0784 241.351 22.281 241.321 22.4838C241.523 22.5777 242.137 22.8017 242.186 22.817C242.38 22.5586 242.561 22.3177 242.744 22.074C243.082 22.109 243.421 22.1439 243.758 22.1789C243.886 22.4658 244.009 22.7442 244.139 23.0387C244.442 22.992 244.734 22.9468 245.027 22.9014C245.061 22.6592 245.076 22.4239 245.107 22.1964C245.118 22.1175 245.13 22.0394 245.146 21.9624C245.275 21.9056 245.4 21.8502 245.525 21.7951C245.704 21.7155 245.883 21.6368 246.062 21.5572C246.312 21.7473 246.555 21.9335 246.813 22.1302C247.048 21.9432 247.284 21.7553 247.523 21.5654C247.397 21.2711 247.277 20.9915 247.154 20.7063C247.373 20.4299 247.547 20.1282 247.783 19.8921C248.093 19.923 248.38 19.9516 248.668 19.9803C248.828 19.712 248.914 19.4272 249.012 19.1329C248.78 18.9592 248.55 18.786 248.29 18.5912C248.313 18.2556 248.352 17.9022 248.401 17.5575C248.678 17.4381 248.934 17.3272 249.185 17.2193C249.245 17.061 249.217 16.7881 249.091 16.2962C248.796 16.2646 248.491 16.2321 248.182 16.1993C248.045 15.8922 247.911 15.5899 247.768 15.2694C247.947 15.0212 248.126 14.7723 248.315 14.5098C248.136 14.2656 247.962 14.0197 247.741 13.8035C247.451 13.9289 247.172 14.0498 246.898 14.1685C246.62 13.9601 246.352 13.7603 246.083 13.5587C246.116 13.2547 246.149 12.9562 246.18 12.666C245.899 12.5155 245.62 12.4161 245.327 12.3352C245.142 12.5819 244.961 12.8222 244.78 13.0631C244.431 13.0222 244.094 12.9831 243.767 12.9448C243.638 12.6568 243.519 12.3908 243.397 12.1192C243.09 12.1177 242.806 12.1685 242.52 12.2422C242.505 12.2978 242.484 12.3462 242.478 12.3966C242.456 12.5817 242.435 12.767 242.422 12.953C242.417 13.0402 242.402 13.1193 242.353 13.1844C242.197 13.2527 242.043 13.3204 241.89 13.3875C241.744 13.4512 241.6 13.5144 241.458 13.5771C241.211 13.3913 240.97 13.2101 240.72 13.022C240.473 13.2043 240.208 13.3647 240.011 13.6121C240.133 13.8874 240.249 14.1482 240.37 14.4202C240.173 14.6918 239.976 14.9621 239.77 15.2459C239.751 15.2439 239.731 15.2419 239.712 15.24C239.424 15.211 239.133 15.1816 238.845 15.1527C238.697 15.4359 238.598 15.7199 238.519 16.0031C238.772 16.1945 239.007 16.3721 239.247 16.5535C239.203 16.8978 239.196 17.2388 239.119 17.577C238.85 17.6953 238.588 17.8101 238.33 17.9234C238.286 18.0772 238.327 18.4257 238.436 18.8189C238.49 18.8293 238.552 18.8438 238.615 18.8522C238.806 18.8779 238.997 18.8998 239.188 18.9259C239.25 18.9346 239.311 18.9514 239.363 18.9625C239.504 19.2834 239.637 19.5857 239.763 19.8733C239.568 20.1343 239.389 20.3745 239.209 20.6154C239.392 20.8661 239.551 21.1258 239.798 21.3191C240.076 21.2023 240.346 21.0888 240.625 20.9716C240.895 21.1666 241.161 21.3587 241.441 21.5615Z" fill="#131313"/>
<path d="M216.838 15.7555L219.184 13.4102V21.7871L216.927 19.9107L214.604 19.9217L214.56 15.9344L216.838 15.7555Z" fill="#131313"/>
<path d="M224.701 23.6667C224.58 23.6667 224.458 23.628 224.355 23.548C224.109 23.3568 224.064 23.0022 224.255 22.7556C227.494 18.5834 224.411 13.5516 224.278 13.3392C224.113 13.0752 224.193 12.7268 224.457 12.5612C224.721 12.3955 225.069 12.4747 225.235 12.7383C225.271 12.7969 228.875 18.6454 225.147 23.448C225.036 23.5916 224.87 23.6667 224.701 23.6667Z" fill="#131313"/>
<path d="M221.609 21.6915C221.488 21.6915 221.366 21.6528 221.264 21.573C221.017 21.3819 220.972 21.027 221.164 20.7807C223.028 18.3782 221.241 15.4511 221.164 15.3276C221 15.0634 221.08 14.7152 221.344 14.5498C221.607 14.3844 221.955 14.4635 222.121 14.7269C222.216 14.8772 224.409 18.4403 222.056 21.4731C221.945 21.6165 221.778 21.6915 221.609 21.6915Z" fill="#131313"/>
<path d="M272.646 12.1299H271.806V14.4729H272.646V12.1299Z" fill="#131313"/>
<path d="M272.646 12.8887V12.1299H270.302V12.8887H272.646Z" fill="#131313"/>
<path d="M272.646 20.2241H271.806V22.5671H272.646V20.2241Z" fill="#131313"/>
<path d="M270.303 21.6782V22.5669H272.646V21.6782H270.303Z" fill="#131313"/>
<path d="M262.367 14.4727H263.24V12.1296H262.367V14.4727Z" fill="#131313"/>
<path d="M264.71 12.9724V12.1299H262.367V12.9724H264.71Z" fill="#131313"/>
<path d="M262.368 22.5669H263.304V20.2239H262.368V22.5669Z" fill="#131313"/>
<path d="M262.367 21.6786V22.5674H264.71V21.6786H262.367Z" fill="#131313"/>
<path d="M208.803 91.8841V79.2422L219.751 85.5632L230.699 91.8841L219.751 98.2052L208.803 104.526V91.8841Z" fill="#131313"/>
<path d="M237.847 78.1421H233.184V105.626H237.847V78.1421Z" fill="#131313"/>
<path d="M80.1993 93.0291V80.3872L69.251 86.7081L58.3027 93.0291L69.251 99.35L80.1993 105.671V93.0291Z" fill="#131313"/>
<path d="M51.1546 106.771H55.8184V79.287H51.1546V106.771Z" fill="#131313"/>
<path d="M130.845 71.4141V114.645L170.86 91.646L130.845 71.4141Z" fill="#FFE94D"/>
<path d="M194.682 14.543H15.0225V18.3121H194.682V14.543Z" fill="#AA92FF"/>
<path d="M93.6314 24.3428H15.0225V28.1119H93.6314V24.3428Z" fill="#AA92FF"/>
</svg>`;

    const titleColor = '#151A2D';
    const priceColor = '#5121F1'
    const titleText = 'This Lesson Awaits You!';
    const recorded_enroll_url = $('.recorded_enroll_anchor').attr('href');
    swal =  Swal.fire({
        html: `
        <div class="swal-content this-lesson-awaits-you-container" style="background-color: #fff;">
            <div class="gotItBtn close-button" style="position: absolute; top: 12px; right: 12px; cursor: pointer;">
                <svg width="40" height="40" viewBox="0 0 30 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 8.5C4.65685 8.5 6 7.15685 6 5.5C6 3.84315 4.65685 2.5 3 2.5C1.34315 2.5 0 3.84315 0 5.5C0 7.15685 1.34315 8.5 3 8.5Z" fill="white"/>
                    <path d="M13 8.5C14.6569 8.5 16 7.15685 16 5.5C16 3.84315 14.6569 2.5 13 2.5C11.3431 2.5 10 3.84315 10 5.5C10 7.15685 11.3431 8.5 13 8.5Z" fill="white"/>
                    <path d="M25 10.5C27.7614 10.5 30 8.26142 30 5.5C30 2.73858 27.7614 0.5 25 0.5C22.2386 0.5 20 2.73858 20 5.5C20 8.26142 22.2386 10.5 25 10.5Z" fill="white"/>
                </svg>
            </div>
            <div class="swal-icon">
                ${iconSvg}
            </div>
            <h2 class="swal-title" style="padding: 25px 0;"><span style="color: ${titleColor};">${titleText}</span></h2>
            <p class="swal-message" style="margin-bottom: 32px;">Want to dive deeper? Join our exclusive recorded course for just <span style="color: ${priceColor}"><br/>${price}</span> and gain unlimited access to all video lessons and course materials.

The next step is yours to take!</p>
            <a class="check-available swall-enroll-now-btn hover-anim-1 m-auto gotItBtn" href="${recorded_enroll_url}">Enroll Now and Unlock Everything
            <div class="arrow">
               <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="fi-rr-angle-small-right">
                    <path id="Vector" d="M12.8336 8.23408L9.0086 4.40908C8.85246 4.25387 8.64125 4.16675 8.4211 4.16675C8.20094 4.16675 7.98973 4.25387 7.8336 4.40908C7.75549 4.48654 7.69349 4.57871 7.65119 4.68026C7.60888 4.78181 7.5871 4.89073 7.5871 5.00074C7.5871 5.11075 7.60888 5.21967 7.65119 5.32122C7.69349 5.42277 7.75549 5.51494 7.8336 5.59241L11.6669 9.40908C11.745 9.48654 11.807 9.57871 11.8493 9.68026C11.8916 9.78181 11.9134 9.89073 11.9134 10.0007C11.9134 10.1108 11.8916 10.2197 11.8493 10.3212C11.807 10.4228 11.745 10.5149 11.6669 10.5924L7.8336 14.4091C7.67668 14.5649 7.58808 14.7767 7.5873 14.9978C7.58652 15.2189 7.67362 15.4313 7.82943 15.5882C7.98524 15.7452 8.19701 15.8338 8.41815 15.8345C8.63929 15.8353 8.85168 15.7482 9.0086 15.5924L12.8336 11.7674C13.3018 11.2987 13.5647 10.6632 13.5647 10.0007C13.5647 9.33824 13.3018 8.70283 12.8336 8.23408Z" fill="#171717"/>
                </g>
            </svg>
            </div>
         
            </a>
        </div>`,
        showConfirmButton: false,
    });

    $(document).on('click', '.gotItBtn', () => {
        if (swal) {
            swal.close();
        }
    });

}
//Disable all video Controls
document.addEventListener("DOMContentLoaded", function() {
    const videoElements = document.querySelectorAll('video');

    let revealAt = 0;

    videoElements.forEach((video) => {
        // Verifică dacă video-ul are atributul preload="none"
        if (video.getAttribute('preload') === 'none') {
            const observerOptions = {
                root: null,
                rootMargin: '100px 0px',
                threshold: revealAt
            };

            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        video.play();
                    } else {
                        video.muted = true;
                        video.pause();
                    }
                });
            }, observerOptions);

            observer.observe(video);
        }

        // Verifică dacă video-ul are atributul progressBar="true"
        if (video.getAttribute('progressBar') === 'true') {
            // Adaugă div-ul progress bar după fiecare video
            video.insertAdjacentHTML('afterend', '<div class="progress-bar-video-general"></div>');
            const progressBar = video.nextElementSibling;

            video.addEventListener('timeupdate', function() {
                // Calculează procentajul parcurs din video
                const percentWatched = (video.currentTime / video.duration) * 100;
                progressBar.style.setProperty('--progress-width', `${percentWatched}%`);
            });
        }
    });
});



